import {
  ArrayFieldItemTemplate,
  ArrayFieldTemplate,
  ArrayFieldTitleTemplate,
  ObjectFieldTemplate,
  AddButton,
  RemoveButton,
  FieldErrorTemplate,
} from '../katal/templates';

/**
 * Generate list of templates for ReactJson Schema.
 * @returns Templates applicable for Katal Theme in React Json Schema
 */
export function generateTemplates() {
  return {
    ArrayFieldTitleTemplate,
    ArrayFieldItemTemplate,
    ArrayFieldTemplate,
    ObjectFieldTemplate,
    FieldErrorTemplate,
    ButtonTemplates: { AddButton, RemoveButton },
  };
}
